import { FileDownloadIcon, TablePager } from '@fukuri-admins/ui/common';
import { AccessLogTableContent } from '~/components/accessLog/AccessLogTableContent';
import { ActionButton } from '~/components/common/ActionButton';
import { ContentsHeader } from '~/components/common/ContentsHeader';
import Shimmer from '~/components/Shimmer';
import styles from './styles.module.scss';

type AccessLogTableContentProps = React.ComponentProps<typeof AccessLogTableContent>;
type Props = {
  rows: AccessLogTableContentProps['rows'];
  pagerProps: React.ComponentProps<typeof TablePager>;
  isLoading: boolean;
  onSort: AccessLogTableContentProps['onSort'];
  onOutputCsv: () => void;
};

export const LoginReportPresentation: React.FC<Props> = ({
  rows,
  pagerProps,
  isLoading,
  onSort,
  onOutputCsv,
}) => (
  <div className={styles.Root}>
    <div className={styles.container}>
      <ContentsHeader
        title='アプリ利用履歴'
        description='以下より、1日の最初にアプリを使用した日時を確認できます。'
        actions={
          <ActionButton
            content='CSV出力'
            type='darkFill'
            icon={<FileDownloadIcon />}
            iconPosition='left'
            action={onOutputCsv}
          />
        }
      />
      {isLoading ? (
        <Shimmer />
      ) : (
        <div>
          <div className={styles.tableWrapper}>
            <AccessLogTableContent rows={rows} onSort={onSort} />
          </div>
          <TablePager {...pagerProps} />
        </div>
      )}
    </div>
  </div>
);
